/**
 * Provider path segments served by the generic external quotes dashboard endpoint
 * (GET /api/public/external_quotes/:provider/dashboard). Register a new alliance here.
 */
export const EXTERNAL_QUOTES_PROVIDER_SEGMENTS = ["santander"] as const;

export type ExternalQuotesProviderSegment = typeof EXTERNAL_QUOTES_PROVIDER_SEGMENTS[number];

/** Type guard limiting the generic dashboard flow to registered providers (never `inbursa`). */
export function isKnownExternalQuotesProvider(
  segment: string | null | undefined
): segment is ExternalQuotesProviderSegment {
  return !!segment && (EXTERNAL_QUOTES_PROVIDER_SEGMENTS as readonly string[]).includes(segment);
}
